module.exports = __webpack_public_path__ + "img/pics04.5e74f3f4.png";